import { useState, useEffect } from 'react';

const CountdownPage = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDate = new Date('2025-10-06T00:00:00Z').getTime();
    
    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'black',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{
          fontSize: '3.75rem',
          fontWeight: 'bold',
          marginBottom: '2rem',
          letterSpacing: '0.05em'
        }}>
          TGE COUNTDOWN
        </h1>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '2rem',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              fontSize: '2.25rem',
              fontFamily: 'monospace',
              fontWeight: 'bold'
            }}>
              {timeLeft.days}
            </div>
            <div style={{ 
              fontSize: '0.875rem',
              marginTop: '0.5rem',
              letterSpacing: '0.1em'
            }}>
              DAYS
            </div>
          </div>
          <div>
            <div style={{
              fontSize: '2.25rem',
              fontFamily: 'monospace',
              fontWeight: 'bold'
            }}>
              {timeLeft.hours}
            </div>
            <div style={{ 
              fontSize: '0.875rem',
              marginTop: '0.5rem',
              letterSpacing: '0.1em'
            }}>
              HOURS
            </div>
          </div>
          <div>
            <div style={{
              fontSize: '2.25rem',
              fontFamily: 'monospace',
              fontWeight: 'bold'
            }}>
              {timeLeft.minutes}
            </div>
            <div style={{ 
              fontSize: '0.875rem',
              marginTop: '0.5rem',
              letterSpacing: '0.1em'
            }}>
              MINUTES
            </div>
          </div>
          <div>
            <div style={{
              fontSize: '2.25rem',
              fontFamily: 'monospace',
              fontWeight: 'bold'
            }}>
              {timeLeft.seconds}
            </div>
            <div style={{ 
              fontSize: '0.875rem',
              marginTop: '0.5rem',
              letterSpacing: '0.1em'
            }}>
              SECONDS
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownPage;
